export const isExternalUrl = (url: string) => url.startsWith('http');
